import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/about/hero.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/people/chris.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/people/Marco.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/contact-form-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/footer-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/header-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/statistics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/team-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/vision-mission.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleSwitch"] */ "/app/src/components/ui/locale-switch.tsx");
